export const API_URL = 'https://ntelgnt.com/api/itqan/remote/query/do_query.php';